<div class="row">
  <div class="col-12 col-lg-6 to-do pt-0 pb-0 pt-md-4 pb-md-5">
    <h4>GETTING STARTED</h4>
    <p>
      Thank you for your participation in the Light The Night Walk. It's easy to get started and support the LLS goal:
      A world without blood cancers.
    </p>
    <div class="steps">
      <div class="step" [class.active]="isStep1Collapsed">
        <h5 (click)="isStep1Collapsed = !isStep1Collapsed"
            [attr.aria-expanded]="!isStep1Collapsed" aria-controls="stepOneCollapse">
          Step 1: Recruit Your Team
          <i class="fa fa-caret-right" aria-hidden="true"></i>
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </h5>
        <div id="stepOneCollapse" [ngbCollapse]="!isStep1Collapsed">
          <div class="card">
            <div class="card-body">
              We ask that each team have 15 walkers who will raise funds and rally with you at the event.
              The bigger your team, the better chance you have of reaching your team fundraising goal.
              To make your recruiting as easy as possible, click on the Team Building Tutorial.
            </div>
          </div>
        </div>
      </div>
      <div class="step" [class.active]="isStep2Collapsed">
        <h5 (click)="isStep2Collapsed = !isStep2Collapsed"
            [attr.aria-expanded]="!isStep2Collapsed" aria-controls="stepTwoCollapse">
          Step 2: Share Your Story
          <i class="fa fa-caret-right" aria-hidden="true"></i>
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </h5>
        <div id="stepTwoCollapse" [ngbCollapse]="!isStep2Collapsed">
          <div class="card">
            <div class="card-body">
              Why do you participate? Share your story by personalizing your fundraising page to inspire others and
              then set your personal fundraising goal! Ask your team to do the same thing!
              Don't forget about your team page. This is a great place to showcase why your team is involved with LTN.
              Find out how here - Fundraising Quick Start Guide. 
            </div>
          </div>
        </div>
      </div>
      <div class="step" [class.active]="isStep3Collapsed">
        <h5 (click)="isStep3Collapsed = !isStep3Collapsed"
            [attr.aria-expanded]="!isStep3Collapsed" aria-controls="stepThreeCollapse">
          Step 3: Lead by Example
          <i class="fa fa-caret-right" aria-hidden="true"></i>
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </h5>
        <div id="stepThreeCollapse" [ngbCollapse]="!isStep3Collapsed">
          <div class="card">
            <div class="card-body">
              Get your 1st gift...from you! Make a personal gift today. Then ask your team to do the same.
            </div>
          </div>
        </div>
      </div>
      <div class="step" [class.active]="isStep4Collapsed">
        <h5 (click)="isStep4Collapsed = !isStep4Collapsed"
            [attr.aria-expanded]="!isStep4Collapsed" aria-controls="stepFourCollapse">
          Step 4: Rally Your Team
          <i class="fa fa-caret-right" aria-hidden="true"></i>
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </h5>
        <div id="stepFourCollapse" [ngbCollapse]="!isStep4Collapsed">
          <div class="card">
            <div class="card-body">
              Here is where the fun starts! Time to get someone fundraising! Online fundraising is the easiest,
              most cost effective method to raise funds. Share team progress. Check in with your team often to continue
              the momentum.  There are a lot of great tools (to the right) that will help you continue to be the
              ' Motivator-in-Chief' and a very successful team.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6 pt-0 pb-0 pt-md-4 pb-md-5">
    <div class="include fundraising pr-xs-0 pb-0 ml-0 ml-xl-5 mt-4">
      <p>
        We applaud your leadership! By leading a LTN team, you help LLS advance targeted therapies that become
        a light of hope in the darkness to the 1.2 million people in the US living with, or who are in remission from,
        a blood cancer.
      </p>
    </div>
  </div>
</div>